import React, { PureComponent } from 'react';
import { Toast } from '../../molecules/Toast';
import { VideoPlayer } from '../../organisms/VideoPlayer';
import { Purchase } from '../../../domain/entities';
import { words } from '../../../constants';

type Props = {
  title: string;
  description: string;
  fileURL: string;
  purchase: Purchase & { pointRefund?: number };
  showToast?: boolean;
};

type State = {
  toastTime?: number;
  toastTitle?: string;
};

export default class VideoContent extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      toastTime: 0,
      toastTitle: '',
    };
  }

  componentDidMount() {
    const { purchase, showToast } = this.props;

    if (purchase && purchase.pointRefund && showToast) {
      this.setToastState(`${purchase.pointRefund}${words.pointsWereRefunded}`);
    }
  }

  setToastState = (toastTitle: string, callback?: () => void) => {
    // Note: Temporary fix. We are still not sure why the toast does not appear when new user buys first purchase from MyPage
    setTimeout(() => {
      this.setState(
        () => ({ toastTime: Date.now(), toastTitle }),
        () => {
          if (callback) {
            callback();
          }
        },
      );
    }, 1000);
  };

  renderToast = (title?: string, toastKey?: string | number) => {
    if (title && toastKey) {
      return (
        <Toast type="reward" title={title} message="" toastKey={toastKey} />
      );
    }
  };

  render = (): React.ReactElement => {
    const { title, description, fileURL } = this.props;
    const { toastTitle, toastTime } = this.state;

    return (
      <>
        {this.renderToast(toastTitle, toastTime)}
        <VideoPlayer
          title={title}
          description={description}
          fileURL={fileURL}
        />
      </>
    );
  };
}
